import React from 'react';
import PropTypes from 'prop-types';

import BaseViewForm from '../0-base-view-form';
import FormManager from 'src/core/gd-form/common/form-manager';
import CommonBlock from "../common-blocks/common-block";
import CommonForm from "../common-blocks/common-form";
import {ViewType} from "../../../../../../../core/gd/const/views/view-type";
import {ViewTypeConfigs} from "../../../../../../../core/gd/const/views/view-type-config";

export default class MyWorkViewProto extends BaseViewForm {

    static propTypes = {
        mode: PropTypes.oneOf(['create', 'update']).isRequired,
        onSubmit: PropTypes.func,
        view: PropTypes.object,
        className: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.viewType = ViewType.CUSTOM_VIEW_TASKS_BY_USER;
        this.defaultName = ViewTypeConfigs[this.viewType].name;

        const initFormData = this.getViewInitFormData(this.props.view, {});

        const formStructure = {
            fields: this.getViewFormFields({}),
            onSubmit: this.onSubmit,
            isFormChanged: true,
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    onSubmit = (result) => {
        this.submitData(result, {});
    }

    render() {

        return (
            <CommonForm className={this.props.className} form={this.form} mode={this.props.mode}>
                <div className="tbl">
                    <CommonBlock form={this.form} mode={this.props.mode} users={this.getUsers()} view={this.props.view} />
                </div>
            </CommonForm>
        );
    }
}